<template>
<v-app>
    <v-snackbar bottom right :timeout="5000" v-model="snackbar.active" color="white" class="grey--text">
        <v-icon :class="`${snackbar.action}--text mr-4`" x-large v-text="snackbar.action == 'success' ? 'mdi-checkbox-marked-circle-outline' : 'mdi-close-circle-outline'"></v-icon>
        <div style="width: 250px">
            <h3 :class="`${snackbar.action}--text text-capitalize`">{{ snackbar.action }}</h3>
            <p>{{snackbar.message}}</p>
        </div>
        <v-btn icon color="primary" text @click="snackbar.active = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-content style="background: #f6f7fb">
        <router-view></router-view>
    </v-content>
</v-app>
</template>

<script>
import {
    mapGetters
} from 'vuex'
export default {
    computed: {
        ...mapGetters(['snackbar'])
    }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Questrial");

.v-application {
  font-family: "Questrial";
}
table.page-user-view td {
    vertical-align: top;
    min-width: 140px;
    padding: .5rem;
    word-break: break-all
}
</style>